import {
  Box,
  Checkbox,
  CheckboxProps,
  FormField,
  NonCancelableCustomEvent,
} from '@amzn/awsui-components-core';
import React from 'react';
import InfoLink from '../../common/InfoLink';

interface Props {
  onChange?: (sectionId: string, isChecked: boolean) => void;
  sectionId?: string;
  readonly?: boolean;
  isChecked: boolean;
  label: string;
  description?: string;
  contextualHelp?: string;
  placeholder?: string;
  isRequired?: boolean;
  disabled?: boolean;
  visible?: boolean;
  showValidationError?: boolean;
}

interface State {
  validationError?: string;
  isChecked: boolean;
}

class MetadataCheckboxInput extends React.Component<Props, State> {
  private static defaultProps = {
    description: '',
    disabled: false,
    isRequired: false,
    placeholder: '',
    readonly: false,
    visible: true,
  };

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = { isChecked: props.isChecked };
  }

  public componentDidUpdate(prevProps: Props) {
    if (
      this.props.isChecked !== prevProps.isChecked &&
      this.props.isChecked !== this.state.isChecked
    ) {
      this.setState({
        isChecked: this.props.isChecked,
      });
    }
  }

  public render() {
    const {
      readonly,
      label,
      description,
      contextualHelp,
      disabled,
      visible,
      showValidationError,
      isRequired,
    } = this.props;
    const { isChecked, validationError } = this.state;
    if (!visible) {
      return null;
    } else if (readonly) {
      return (
        <div>
          <span>
            <Box variant="strong">{label}:</Box> {isChecked ? 'Yes' : 'No'}
          </span>
        </div>
      );
    } else {
      return (
        <FormField
          errorText={showValidationError && validationError}
          label={
            <span>
              {label}
              {!isRequired && <i> - optional</i>}
            </span>
          }
          info={contextualHelp && <InfoLink topic={contextualHelp} />}
          description={description}
          i18nStrings={{ errorIconAriaLabel: 'Error' }}
        >
          <Checkbox onChange={this.handleChange} checked={isChecked} disabled={disabled}>
            {label}
          </Checkbox>
        </FormField>
      );
    }
  }

  private handleChange = (e: NonCancelableCustomEvent<CheckboxProps.ChangeDetail>) => {
    const isChecked: boolean = e.detail.checked;

    this.setState({ isChecked });

    const { onChange, sectionId } = this.props;

    if (onChange) {
      // @ts-expect-error TS2345 - strict migration
      onChange(sectionId, isChecked);
    }
  };
}

export default MetadataCheckboxInput;
